import BhelLogo from '../../../assets/icons/bhel-logo.svg';

const Loader = ({ className }) => {
        return (
                <div className={`flex justify-center items-center h-screen ${className}`}>
                        <div className="flex flex-col items-center ">
                                <img
                                        src={BhelLogo}
                                        alt="Loading..."
                                        className="w-20 h-auto mb-3"
                                />
                                <div className="flex space-x-1 mb-2">
                                        <div
                                                className="w-2 h-2 bg-[#2C3F7E] rounded-full animate-bounce"
                                                style={{ animationDelay: '0s' }}></div>
                                        <div
                                                className="w-2 h-2 bg-[#2C3F7E] rounded-full animate-bounce"
                                                style={{ animationDelay: '0.2s' }}></div>
                                        <div
                                                className="w-2 h-2 bg-[#2C3F7E] rounded-full animate-bounce"
                                                style={{ animationDelay: '0.4s' }}></div>
                                </div>
                                <p className="text-[20px] font-medium text-[#667085] leading-[150%] tracking-[0%]">Project Execution Planning System</p>
                                <p className="text-[14px] font-normal text-[#667085] leading-[150%] tracking-[0%]">Please wait...</p>
                        </div>
                </div>
        );
};

export default Loader;
